import superagent from 'superagent'
import Promise from 'promise'

let config = require('config');

let POSTS_URL           = "/wp-json/wp/v2/posts/"
let SHOW_POSTS_URL      = "/wp-json/show_posts/v1/"
let SHOW_TOTAL_PAGE_URL = "/wp-json/show_total_post/v1/"

let INDEX_POSTS_URL      = "/wp-json/index_posts/v1/"
let INDEX_TOTAL_PAGE_URL = "/wp-json/index_total_post/v1/"

let INDEX_PAGE_URL = "/wp-json/wp/v2/index_page/"
let CATEGORY_URL   = "/wp-json/wp/v2/categories/"

export const FETCH_INDEX_POSTS      = 'FETCH_INDEX_POSTS'
export const FETCH_SHOW_POSTS       = 'FETCH_SHOW_POSTS'
export const FETCH_SINGLE_POST      = 'FETCH_SINGLE_POST'
export const GET_INDEX_POSTS        = 'GET_POSTS'
export const GET_SHOW_POSTS         = 'GET_SHOW_POSTS'
export const GET_INDEX_POSTS_BY_CAT = 'GET_POSTS_BY_CAT'
export const GET_TOTAL_SHOW_PAGE    = 'GET_TOTAL_SHOW_PAGE'
export const GET_TOTAL_INDEX_PAGE   = 'GET_TOTAL_INDEX_PAGE'
export const GET_INDEX_PAGE         = 'GET_INDEX_PAGE'
export const GET_CATEGORIES         = 'GET_CATEGORIES'
export const GET_SINGLE_POST        = 'GET_SINGLE_POST'

export const SET_CURRENT_SHOW_PAGE   = 'SET_CURRENT_SHOW_PAGE'
export const SET_CURRENT_INDEX_PAGE  = 'SET_CURRENT_INDEX_PAGE'
export const SET_CURRENT_SINGLE_SLUG = 'SET_CURRENT_SINGLE_SLUG'

export const INDEX_OPEN  = 'INDEX_OPEN'
export const INDEX_CLOSE = 'INDEX_CLOSE'

const send = (name, res, offset, cat=null) => {
  switch (name) {
    case "fetchindexposts": {
      return {
        type:FETCH_INDEX_POSTS
      }
    } break;
    case "fetchshowposts": {
      return {
        type:FETCH_SHOW_POSTS
      }
    } break;
    case "fetchsinglepost": {
      return {
        type:FETCH_SINGLE_POST
      }
    } break;
    case "getindexposts": {
      return {
        type:GET_INDEX_POSTS,
        body:res.body,
        offset:offset
      }
    } break;
    case "getindexpostsbycat": {
      return {
        type:GET_INDEX_POSTS_BY_CAT,
        body:res.body,
        offset:offset,
        cat:cat
      }
    } break;
    case "getshowposts": {
      return {
        type:GET_SHOW_POSTS,
        body:res.body,
        offset:offset
      }
    } break;
    case "gettotalshowpage": {
      return {
        type:GET_TOTAL_SHOW_PAGE,
        body:res.body
      }
    } break;
    case "gettotalindexpage": {
      return {
        type:GET_TOTAL_INDEX_PAGE,
        body:res.body
      }
    } break;
    case "getindexpage": {
      return {
        type:GET_INDEX_PAGE,
        body:res.body
      }
    } break;
    case "getcategories": {
      return {
        type:GET_CATEGORIES,
        body:res.body
      }
    } break;
    case "getsinglepost": {
      return {
        type:GET_SINGLE_POST,
        body:res.body,
        slug:offset
      }
    } break;
  }
}

export const getShowPosts = (offset) => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchshowposts', null))
      if (offset > 0) offset -= 1
      var url = config.default.HOST + SHOW_POSTS_URL + (offset * config.default.PAGE_MAX) + "/" + config.default.PAGE_MAX + "/"
      superagent
      .get(url)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("getshowposts", res, offset))
      })
    })
  }
}

export const getIndexPosts = (offset) => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchindexposts', null))
      if (offset > 0) offset -= 1
      var url = config.default.HOST + INDEX_POSTS_URL + (offset * config.default.PAGE_MAX) + "/" + config.default.PAGE_MAX + "/"
      superagent
      .get(url)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("getindexposts", res, offset, null))
      })
    })
  }
}

export const getIndexPostsByCat = (offset, catId) => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchindexposts', null))
      if (offset > 0) offset -= 1
      var url = config.default.HOST + INDEX_POSTS_URL + (offset * config.default.PAGE_MAX) + "/" + config.default.PAGE_MAX + "/" + catId
      superagent
      .get(url)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("getindexpostsbycat", res, offset, catId))
      })
    })
  }
}

export const getTotalShowPage = () => {
  return dispatch => {
    return new Promise(() => {
      var url = config.default.HOST + SHOW_TOTAL_PAGE_URL
      superagent
      .get(url)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("gettotalshowpage", res, null))
      })
    })
  }
}

export const getTotalIndexPage = (cat = null) => {
  return dispatch => {
    return new Promise(() => {
      var param = ""
      if (cat) {
        param = cat
      }
      var url = config.default.HOST + INDEX_TOTAL_PAGE_URL + param
      superagent
      .get(url)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("gettotalindexpage", res, null))
      })
    })
  }
}

export const getIndexPage = () => {
  return dispatch => {
    return new Promise(() => {
      var url = config.default.HOST + INDEX_PAGE_URL
      superagent
      .get(url)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("getindexpage", res, null))
      })
    })
  }
}

export const getCategories = () => {
  return dispatch => {
    return new Promise(() => {
      var url = config.default.HOST + CATEGORY_URL
      superagent
      .get(url)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("getcategories", res, null))
      })
    })
  }
}

export const getSingleBySlug = (slug) => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchsinglepost', null))
      var url = config.default.HOST + POSTS_URL + "?slug=" + slug
      superagent
      .get(url)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("getsinglepost", res, slug))
      })
    })
  }
}

export const setCurrent = (num) => {
  return {
    type:SET_CURRENT_SHOW_PAGE,
    num:num
  }
}

export const setCurrentIndex = (num) => {
  return {
    type:SET_CURRENT_INDEX_PAGE,
    num:num
  }
}

export const setCurrentSingleSlug = (slug) => {
  return {
    type:SET_CURRENT_SINGLE_SLUG,
    slug:slug
  }
}

export const indexOpen = (scrollTop) => {
  return {
    type:INDEX_OPEN,
    scrollTop:scrollTop
  }
}

export const indexClose = () => {
  return {
    type:INDEX_CLOSE,
    scrollTop:0
  }
}

export const removeSinglePost = () => {
  return {
    type:GET_SINGLE_POST,
    body:null,
    slug:null
  }
}



// WEBPACK FOOTER //
// ./src/actions/const.js